
import { defineComponent } from "vue";
import api, {
  Correlation,
  ReceiverEventList,
  RequestFilter,
  RequestParams,
} from "../../api/backend-api";
import { getHumanDate, getHumanDateDiff } from "../../util/luxonDateHelpers";
import format from "xml-formatter";
import { AxiosError } from "axios";
import ErrorBlock from "@/components/ErrorBlock.vue";

interface State {
  msg: string;
  event: Correlation;
  eventErrors: ReceiverEventList;
  errors: AxiosError[];
}

export default defineComponent({
  name: "ReceiverCorrelationForm",
  components: { ErrorBlock },
  mounted() {
    this.$nextTick(() => {
      this.callGetCorrelation();
    });
  },
  data: (): State => {
    let event = {} as Correlation;
    return {
      msg: "Processing Event",
      event: event,
      eventErrors: {} as ReceiverEventList,
      errors: [],
    };
  },
  methods: {
    getHumanDate,
    getHumanDateDiff,
    formatXml(xml: string): string {
      return format(xml, { collapseContent: false });
    },
    callRetry() {
      const correlation = {
        id: this.event.id,
        LatestReceiverStatus: "received",
      } as Correlation;
      api
        .saveCorrelation(correlation)
        .then((response) => {
          this.event = response.data;
        })
        .catch((error: AxiosError) => {
          this.errors.push(error.response?.data.message);
        });
    },
    callGetCorrelationError() {
      const err_param = [
        {
          Filter: "Initiator",
          Eq: "system",
        },
        {
          Filter: "Class",
          Eq: "error",
        },
        {
          Filter: "Condition",
          Eq: "instant",
        },
        {
          Filter: "Message",
          Eq: "Event processing failure",
        },
        {
          Filter: "Data",
          Match: '"correlation": "' + this.event.id + '"',
        },
      ] as RequestFilter[];
      const request_params = {
        Filters: err_param,
      } as RequestParams;

      api
        .getEventList(request_params)
        .then((response) => {
          this.eventErrors = response.data;
        })
        .catch((error: AxiosError) => {
          this.errors.push(error.response?.data.message);
        });
    },
    callGetCorrelation() {
      this.errors = [];
      let correlation_id = "";
      if (typeof this.$route.params.slug != "string") {
        throw new Error("Invalid url");
      }
      correlation_id = this.$route.params.slug;

      api
        .getCorrelation(correlation_id)
        .then((response) => {
          this.event = response.data;
          if (this.event.LatestReceiverStatus == "failed") {
            this.callGetCorrelationError();
          }
        })
        .catch((error: AxiosError) => {
          this.errors.push(error.response?.data.message);
        });
    },
  },
});
